import * as React from 'react'
import { useState } from 'react'
import { Grid, Typography, Box, Drawer } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import MoreSidebar from './MoreSidebar/MoreSidebar'
import useStyles from './useStyles'

export default function MoreItem () {
  const classes = useStyles()

  const [state, setState] = useState({
    left: false
  })

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, left: open })
  }

  const closeSubMenu = () => {
    setState({ ...state, left: false })
  }
  // const list = (anchor) => (
  //   <Box
  //     role="presentation"
  //     onClick={toggleDrawer(anchor, false)}
  //     onKeyDown={toggleDrawer(anchor, false)}
  //   >
  //     <MoreSidebar
  //       toggleSubMenu={toggleSubMenu}
  //       subMenuOpen={state.subMenuOpen}
  //     />
  //   </Box>
  // )

  return (
    <div>
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Grid
            item
            className={classes.menuItem}
            onClick={toggleDrawer(anchor, true)}
          >
            <Box
              style={{ textDecoration: 'none' }}
              className={state.left ? classes.linkActive : classes.link}
            >
              <Grid container direction="column" alignItems="center">
                <Grid
                  id={'panelIcon'}
                  container
                  item
                  justifyContent="center"
                  className={classes.icon}
                >
                  <MoreHorizIcon />
                </Grid>
                <Grid container item justifyContent="center">
                  <Typography
                    className={classes.linkText}
                    id={'bold'}
                    style={{ textDecoration: 'none' }}
                  >
                    Más
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(false)}
          >
            <MoreSidebar closeSubMenu={closeSubMenu} />
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  )
}
